import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { v4 as uuidv4 } from 'uuid'

import {Order} from "@/models/sales/Order";
import Customer from "@/models/customer/Customer";
import {useI18n} from "vue-i18n";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function handleNewSale(t, customer: Customer = null) {

  let editableTabs: any[] = [];
  let tabIndex: number = 1;
  let editableTabsValue: any = 1;

  const localTabs = localStorage.getItem('checkoutTabs')
  const localTabIndex = localStorage.getItem('checkoutTabIndex')
  const localTabValue = localStorage.getItem('checkoutTabValue')

  if (localTabs) {
    editableTabs = JSON.parse(localTabs)
  } else {
    editableTabs.push({
      id: uuidv4(),
      title: `${t('sale')} #1`,
      name: 1,
      content: '',
      order: new Order()
    })
  }

  if (localTabIndex) {
    tabIndex = Number.parseInt(localTabIndex)
  }

  if (localTabValue) {
    editableTabsValue = Number.parseInt(localTabValue)
  }


  if (editableTabs.length >= 0 && ((editableTabs[0].order as Order).orderItems.length || (editableTabs[0].order as Order).customer) || (customer && (editableTabs[0].order as Order).customerID != customer.id)) {
    const newTabName = ++tabIndex
    let tabTitle = `${t('sale')} #${tabIndex}`;
    const order = new Order();
    if (customer) {
      tabTitle = customer.name;
      order.customer = customer
      order.invoice.customer = customer
      order.invoice.customerID = customer.id
      order.customerID = customer.id
    }

    editableTabs.push({
      id: uuidv4(),
      title: tabTitle,
      name: newTabName,
      content: '',
      order: order
    })
    editableTabsValue = newTabName

    localStorage.setItem('checkoutTabs', JSON.stringify(editableTabs))
    localStorage.setItem('checkoutTabIndex', JSON.stringify(tabIndex))
    localStorage.setItem('checkoutTabValue', JSON.stringify(editableTabsValue))
  }
}

export function canBePreviewed(filename: string): boolean {
  const previewableExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.pdf'];
  const extension = filename.toLowerCase().slice(filename.lastIndexOf('.'));
  return previewableExtensions.includes(extension);
}

export function isImage(filename: string): boolean {
  const previewableExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
  const extension = filename.toLowerCase().slice(filename.lastIndexOf('.'));
  return previewableExtensions.includes(extension);
}


export function isPDF(filename: string): boolean {
  const previewableExtensions = ['.pdf'];
  const extension = filename.toLowerCase().slice(filename.lastIndexOf('.'));
  return previewableExtensions.includes(extension);
}
